import { Swiper, Navigation, Pagination } from 'swiper';
import ProductJSON from '../pages/product-page/product-json';

export default ProductRelatedClosures = () => {
    const initSwiper = (section) => {
        Swiper.use(Navigation, Pagination);
        const recommendedProductCarousel = section.querySelectorAll('.swiper').forEach(carousel => {
            const swiper = new Swiper(carousel, {
                direction: 'horizontal',
                slidesPerView: 1.2,
                spaceBetween: 16,
                navigation: {
                    nextEl: '.product-related-closures .swiper-button-next',
                    prevEl: '.product-related-closures .swiper-button-prev',
                },
                breakpoints: {
                    576: {
                        slidesPerView: 1.8,
                    },
                    768: {
                        slidesPerView: 2.2,
                    },
                    992: {
                        slidesPerView: 4,
                    },
                }
            });
        })
    }

    const init = () => {
        const productRelatedClosuresSection = document.querySelectorAll('.product-related-closures');
        productRelatedClosuresSection.forEach(section => {
            sectionInner = section.querySelector('.product-section-recommendations__inner')

            
            const hasDynamicCollection = sectionInner.dataset.dynamicCollection != null ? true : false;
            const producType = sectionInner.dataset.type;
            let url = '';
            if( hasDynamicCollection ){
                url = window.Shopify.routes.root + 'collections/'+ sectionInner.dataset.dynamicCollection+'/?view=ajax'
            }
            if( !hasDynamicCollection ){

                if( producType == 'Closure'){
                    if( !hasDynamicCollection){
                        let { currentVariant, productOptions  } = ProductJSON();
                        if( productOptions ){
                            neckFinishPosition = productOptions.findIndex( option => option.name == 'Neck Finish');
                            lengthPosition = productOptions.findIndex( option => option.name == 'Length');
                        }
                        let neckFinishes = '&filter.v.option.neck+finish=' + productOptions[ neckFinishPosition ].values.join('&filter.v.option.neck+finish=')
                        let lengths = '&filter.v.m.variant.length=' + productOptions[ lengthPosition ].values.join('&filter.v.m.variant.length=')
                        url = window.Shopify.routes.root + 'collections/all/?view=image-list-ajax'
                        url += '&filter.p.product_type=Item'
                        url += neckFinishes
                        url += lengths
                        url += '&filter.p.tag=Featured'
                    }
                }

                if( producType == 'Item'){
                    let { currentVariant, productVariantMeta, productOptions  } = ProductJSON();
                    let currentVariantMeta = {};
                    if( productVariantMeta ){
                        if( productVariantMeta.hasOwnProperty( currentVariant.id )){
                            currentVariantMeta = productVariantMeta[ currentVariant.id ];
                        }
                    }
                    if( productOptions ){
                        neckFinishPosition = productOptions.findIndex( option => option.name == 'Neck Finish');
                    }
                    let neckFinish = currentVariant.options[ neckFinishPosition ];
        
                    url = window.Shopify.routes.root + 'collections/all/?view=ajax'
                    url += '&filter.p.product_type=Closure'
                    url += '&filter.v.option.neck+finish=' + neckFinish
                    url += '&filter.v.m.variant.length=' + currentVariantMeta.length
                }
            }


            fetch(url)
            .then(response => response.text())
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;

                const slides = html.querySelectorAll('.product-grid-item');

                if (slides.length > 0) {
                    section.classList.remove('d-none')
                    const recommendedPlaceholders = sectionInner.querySelector('.swiper-wrapper');
                    slides.forEach( slide => {
                        const wrapper = document.createElement('div')
                        wrapper.classList.add('swiper-slide')
                        wrapper.appendChild(slide)
                        recommendedPlaceholders.appendChild(wrapper)
                    })
    
                    initSwiper(section);
                } else {
                    section.classList.add('d-none')
                }

            });
        });
    }

    // For shopify customizer/editor
    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-recommendations") {
            init();
        }
    });

    init();
}